import React from 'react';
import { ComparisonTable, type ComparisonRow } from './ComparisonTable';
const rows: ComparisonRow[] = [{
  left: 'Not knowing the catering service fee sits on top of the bill',
  right: '15–25% on your single biggest line — hundreds to thousands, discovered too late to renegotiate'
}, {
  left: 'Alterations, postage, vendor meals and tips, unbudgeted',
  right: '$800–$2,000+, landing in the months you have the least room'
}, {
  left: 'Booking vendors out of order',
  right: 'Deposits that don’t transfer, stationery reprinted, dates that no longer work'
}, {
  left: 'Rebuilding your own spreadsheet and timeline from scratch',
  right: '40+ hours you were supposed to spend being engaged'
}, {
  left: 'No plan for the final two weeks',
  right: 'The part every couple names as the worst — plus whatever gets forgotten on the day'
}];
export function CostOfInaction() {
  return <section aria-labelledby="cost-heading" className="w-full bg-ivory" data-id="element-71" data-mp="3sji0k027kh04">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-72" data-mp="3ei15u1dl5htj">
        <h2 id="cost-heading" className="font-serif font-normal text-ink text-[28px] sm:text-[38px] leading-tight text-center" data-id="element-73" data-mp="39h3ofr0egrt3">
          What does &ldquo;we&apos;ll figure it out as we go&rdquo; actually
          cost?
        </h2>

        <div className="mt-12" data-id="element-74" data-mp="30j1hkutzj4xw">
          <ComparisonTable headers={['Without the plan', 'The real cost']} rows={rows} emphasis="cost" caption="The cost of planning without a sequence" data-id="element-75" data-mp="11tfbyy3embt" />
        </div>

        <p className="mt-5 text-[13px] text-ink-soft" data-id="element-76" data-mp="3nftjl13nshet">
          Source: The Knot Real Weddings Study.
        </p>

        <p className="mt-12 font-serif italic text-ink text-[21px] sm:text-[28px] leading-snug text-center" data-id="element-77" data-mp="3jfatpclbtlf9">
          In the industry&apos;s biggest study, more than half of couples went
          over budget — by around $7,900 on average.
        </p>
        <p className="mt-5 text-center text-[17px] sm:text-[18px] font-semibold text-sage-deep" data-id="element-78" data-mp="298wx5vrlgybt">
          This plan costs less than one forgotten line item.
        </p>
      </div>
    </section>;
}